import React from 'react';
import { useLanguage, Language } from '../contexts/LanguageContext';
import { Button } from './ui/button';
import { Globe, Maximize, Minimize } from 'lucide-react';
import { useIsMobile } from '../hooks/use-mobile';

const Header = ({ isMiniMode, toggleMiniMode }) => {
  const { language, setLanguage, t } = useLanguage();
  const isMobile = useIsMobile();

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
  };

  return (
    <header className={`flex items-center justify-between w-full border-b bg-white dark:bg-gray-900 ${isMiniMode ? 'p-2' : 'p-3'}`}>
      <div className="flex items-center space-x-2">
        <div className={`rounded-full bg-grocery-primary flex items-center justify-center ${isMiniMode ? 'w-5 h-5' : 'w-8 h-8'}`}>
          <svg xmlns="http://www.w3.org/2000/svg" className={`text-white ${isMiniMode ? 'h-3 w-3' : 'h-5 w-5'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
        </div>
        <h1 className={`font-semibold ${isMiniMode ? 'text-xs' : 'text-lg'}`}>Grocery Genie</h1>
      </div>
      <div className="flex items-center gap-1 sm:gap-2">
        {/* Language Dropdown (simplified for now) */}
        <Button variant="ghost" size="icon" className={`relative ${isMiniMode ? 'h-6 w-6' : 'h-8 w-8'}`} onClick={() => handleLanguageChange(language === 'en' ? 'ar' : 'en')}>
          <Globe className={isMiniMode ? 'h-3 w-3' : 'h-5 w-5'} />
        </Button>
        <Button 
          variant="ghost" 
          size="icon" 
          onClick={toggleMiniMode}
          className={isMiniMode ? 'h-6 w-6' : 'h-8 w-8'}
        >
          {isMiniMode ? 
            <Maximize className="h-3 w-3" /> : 
            <Minimize className="h-5 w-5" />
          }
        </Button>
      </div>
    </header>
  );
};

export default Header; 